const initialState = {
  totalPendindOrders: 0,
  savingOrder: false,
  orderCreatedFromModal: false,
  orderCreated: {},
  openUpdateOrderModal: false,
  selectedOrder: null,
  saveAction: '',
  platform: '',
  shippingCostsCache: {} // Caché para costos de envío
};

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TOTAL_PENDING_ORDERS":
      return {
        ...state,
        totalPendindOrders: action.data.pending_orders,
      };
    case "START_SAVING_ORDER_REQUEST":
      return {
        ...state,
        savingOrder: true,
      };
    case "END_SAVING_ORDER_REQUEST":
      return {
        ...state,
        savingOrder: false,
      };
    case "SET_ORDER_CREATED_FROM_MODAL_STATUS":
      return {
        ...state,
        orderCreatedFromModal: action.data.status,
        saveAction: '',
        platform: ''
      };
    case "SET_ORDER_CREATED":
      return {
        ...state,
        orderCreatedFromModal: true,
        orderCreated: action.orderCreated,
        saveAction: action.saveAction,
        platform: action?.platform
      };
    case "TOGGLE_UPDATE_ORDER_MODAL":
      return {
        ...state,
        openUpdateOrderModal: action.data.toggle,
        selectedOrder: action.data.selectedOrder,
        platform: action.data.platform
      };
    case "CACHE_SHIPPING_COSTS":
      return {
        ...state,
        shippingCostsCache: {
          ...state.shippingCostsCache,
          [action.payload.key]: action.payload.options
        }
      };
    case "CLEAR_SHIPPING_COSTS_CACHE":
      return {
        ...state,
        shippingCostsCache: {}
      };
    default:
      return state;
  }
};

export default ordersReducer;
